export default __webpack_public_path__ + "static/media/BANNER-FULL-MOBILE_Covid_01_Sanguineo.52f1a88f.png";